import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import coachImage from '../assets/images/coach.jpg';
import clientLogos from '../assets/images/client-logos.png';
import { FaMedium, FaTwitter, FaLinkedin } from 'react-icons/fa';

const About = () => {
  return (
    <AboutSection id="about">
      <div className="container">
        <AboutGrid>
          <motion.div
            className="about-content"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <AboutContent>
              <h2>About Your Coach, Rizwan Pabani</h2>
              <p>
                With over 20 years of experience at the intersection of technology and business, I've had the privilege of guiding numerous organisations and individuals in harnessing the power of technology.
              </p>
              <p>
                Artificial Intelligence presents a once-in-a-generation opportunity to dramatically increase human productivity. I recently completed an AI Product Design program at MIT, deep-diving into the latest advancements in AI models and tools. Having spent the last year testing cutting-edge AI systems, I believe we’re far further ahead than most people realise.
              </p>
              <p>
                I launched DreamsAIcanbuy to give founders, CEOs, and business leaders hands-on exposure to the most powerful AI tools available today. I know that busy professionals don't have time to sift through endless YouTube videos, articles, or AI courses—so I've done the work for you. In my sessions, I showcase a curated selection of AI tools that are significantly more advanced than what most people are using today.
              </p>
              <p>
                My approach focuses on demystifying complex AI concepts, making them accessible and directly relevant to your specific needs. I'm passionate about making AI practical, actionable, and easy to adopt, so you walk away ready to become a more productive, AI-powered version of yourself.
              </p>
            </AboutContent>
          </motion.div>
          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <AboutImage>
              <img src={coachImage} alt="AI Strategy Coach" />
            </AboutImage>
          </motion.div>
        </AboutGrid>
        
        <motion.div
          className="clients"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Clients>
            <h3> </h3>
            <ClientLogos>
              <img src={clientLogos} alt="Client Logos" />
            </ClientLogos>
          </Clients>
        </motion.div>

        <FollowMe>
          <h3>Follow Me</h3>
          <SocialIcons>
            <a href="https://rizpabani.medium.com/" target="_blank" rel="noopener noreferrer"><FaMedium /></a>
            <a href="https://x.com/rizpabani" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://www.linkedin.com/in/rizpabani/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          </SocialIcons>
        </FollowMe>
      </div>
    </AboutSection>
  );
};

const AboutSection = styled.section`
  background-color: var(--white);
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
  align-items: center;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const AboutContent = styled.div`
  h2 {
    margin-bottom: 1.5rem;
    font-size: 2.2rem;
  }
  
  p {
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
  }
  
  @media (max-width: 768px) {
    h2 {
      font-size: 1.8rem;
    }
    
    p {
      font-size: 1rem;
    }
  }
`;

const AboutImage = styled.div`
  img {
    border-radius: 8px;
    box-shadow: var(--shadow);
    width: 75%; /* Reduced by 20% */
  }
  
  @media (max-width: 992px) {
    margin-bottom: 2rem;
    order: -1;
  }
`;

const Clients = styled.div`
  margin-top: 4rem;
  text-align: center;
  
  h3 {
    margin-bottom: 2rem;
    font-size: 1.8rem;
  }
`;

const ClientLogos = styled.div`
  max-width: 900px;
  margin: 0 auto;
  
  img {
    width: 100%;
  }
`;

const FollowMe = styled.div`
  margin-top: 4rem;
  text-align: center;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  font-size: 2rem;

  a {
    color: inherit;
    transition: color 0.3s;

    &:hover {
      color: var(--primary-color);
    }
  }
`;

export default About;
